import {
  Fragment,
  useState,
} from 'react';

import { IoIosArrowDown } from 'react-icons/io';

import {
  Menu,
  Transition,
} from '@headlessui/react';

import CheckIcon from '../assets/icons/CheckIcon';

const getBrandName = (id, options) => {
  const brand = options.find((option) => {
    return option.id === id;
  });
  return brand?.title ? brand?.title : id.split(/\d/, 1).join().trim();
};

const DropDown = ({ options, handleClick }) => {
  const [, setActive] = useState(localStorage.getItem("activeBrand"));

  const onOptionClick = (brandId) => {
    setActive(brandId);
    localStorage.setItem("activeBrand", brandId);
    handleClick(brandId);
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex w-44 bg-zinc-800 text-white items-center justify-between gap-x-1.5 rounded-md  p-2 text-sm  shadow-sm ring-1 ring-inset ring-zinc-700 hover:bg-zinc-700 duration-300">
          <h3 className="text-sm truncate">
            {getBrandName(localStorage.getItem("activeBrand"), options)}
          </h3>
          <div className=" text-gray-400">
            <IoIosArrowDown className="h-5 w-5" aria-hidden="true" />
          </div>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-64 h-64 overflow-y-auto overflow-x-hidden origin-top-right rounded-md bg-zinc-800 shadow-lg ring-1 ring-zinc-700  focus:outline-none">
          <div className="py-1">
            {options?.map((option) => {
              return (
                <Menu.Item key={option.id}>
                  <button
                    className={`${
                      option.id === localStorage.getItem("activeBrand")
                        ? "text-white font-medium bg-zinc-700"
                        : "text-zinc-300 hover:bg-zinc-700"
                    } w-full p-2 text-sm text-left flex gap-2 items-center`}
                    onClick={() => onOptionClick(option.id)}
                  >
                    {option.id === localStorage.getItem("activeBrand") ? (
                      <CheckIcon className="w-4 h-4" />
                    ) : (
                      <div className="w-4 h-4"></div>
                    )}
                    {option.title}
                  </button>
                </Menu.Item>
              );
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default DropDown;
